import React, {Fragment} from 'react';
import classNames from "classnames";
import PropTypes from "prop-types";
import isEqual from "lodash-es/isEqual";

class TextArea extends React.Component {

    static propTypes = {
        role: PropTypes.any,
        onBlur: PropTypes.func,
        saveChanges: PropTypes.func,
        onKeyDown: PropTypes.func,
        label: PropTypes.any,
        focus: PropTypes.bool,
        select: PropTypes.bool,
        autocomplete: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        required: PropTypes.bool,
        disabled: PropTypes.oneOf([true, false, "true", "false", "disabled"]),
        readOnly: PropTypes.any,
        error: PropTypes.any,
        value: PropTypes.any,
        placeholder: PropTypes.any,
        name: PropTypes.string,
        className: PropTypes.any,
        disablePaste: PropTypes.bool,
        formatter: PropTypes.func,
    };

    state = {
        value: null,
        focus: false
    }

    focus = () => {
        this.input.focus();
    }

    select = () => {
        if (this.input) {
            this.input.select && this.input.select();
            this.input.setSelectionRange && this.input.setSelectionRange(0, this.input.value.length);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.onBlur && prevProps.onBlur) {
            this.setState({value: null});
        }
        if (this.props.focus && this.input) {
            this.input.focus();
        }
        if (this.props.select && this.input) {
            this.select();
        }
        if (this.props.value !== prevProps.value) {
            this.setState({value: this.props.value});
        }
    }

    componentDidMount() {
        if (this.props.focus && this.input) {
            this.input.focus();
        }
        if (this.props.select && this.input) {
            this.select();
        }
    }

    onFocus = () => this.setState({focus: true, value: this.props.value});

    onBlur = (e) => {
        this.setState({focus: false}, () => {
            if (!isEqual(this.state.value, this.props.value)) {
                const v = this.state.value;
                this.setState({value: null}, () => {
                    if (this.props.onBlur) {
                        this.props.onBlur(e, this.props.name, v);
                    }
                });
            }
        });
    }

    onChange = (e) => {
        this.setState({value: e.target.value});
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, e.target.value, e);
        }
    }

    onKeyDown = (e) => {
        this.setState({value: e.target.value});
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e, this.props.name, e.target.value);
        }
    }

    filterProps = (props) => {
        const filterProps = {...props};
        if (filterProps.select !== undefined) {
            delete filterProps.select;
        }
        if(filterProps.focus !== undefined) {
            filterProps.focus = filterProps.focus ? "true" : "false";
        }
        if(filterProps.saveChanges !== undefined) {
            delete filterProps.saveChanges;
        }
        if (filterProps.nolabel !== undefined) {
            delete filterProps.nolabel;
        }
        if (filterProps.label === false) {
            filterProps.label = "";
        }
        if (filterProps.formId !== undefined) {
            delete filterProps.formId;
        }
        if (filterProps.formatter !== undefined) {
            delete filterProps.formatter;
        }
        return filterProps;
    }

    render() {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }

        const value = this.state.value !== null && this.state.value !== undefined ? this.state.value : (this.props.value !== null && this.props.value !== undefined ? this.props.value : '');

        let formatted = value;
        // !(this.input && this.input === document.activeElement)
        if (!this.state.focus && this.props.formatter) {
            formatted = this.props.formatter(value);
            if (formatted instanceof Function) {
                formatted = formatted();
            } else if (formatted instanceof Object && ((formatted || {}).props || {})) {
                formatted = (formatted.props || {}).children || "";
            }
        }

        return <Fragment>
            <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
            <textarea
                ref={(el) => {
                    this.input = el;
                    if (this.input) {
                        this.input.onpaste = e => {
                            if (this.props.disablePaste) {
                                e.preventDefault();
                                return false;
                            }
                        }
                    }
                }}
                {...this.filterProps(this.props)}
                autoComplete={this.props.autocomplete || "off"}
                value={formatted}
                name={this.props.name}
                placeholder={this.props.placeholder}
                className={classNames("p-inputtext p-component form-control", {"is-invalid": this.props.error}, this.props.className)}
                onChange={this.onChange}
                onInput={this.handleChange}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                onKeyDown={this.onKeyDown}
                disabled={this.props.disabled || this.props.role === "idfield"}
                readOnly={this.props.readOnly === true || this.props.readOnly === "true" || this.props.readOnly === "readonly"}
            />
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </Fragment>;
    }
}

export default TextArea;